import React from 'react';

import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';

function ReportQuestion({ onClick, className }) {
  return (
    <span className={`${className || ''} up tooltip-hover-questions`}>
      <div className='tootip_box'> {language.LC().REPORT_THIS_QUESTION} </div>
      <div className='report-icon-wrapper' onClick={onClick}>
        <img src={App_data.frontend_url + '/img/report4.png'} alt='report' />
      </div>
    </span>
  );
}

export default ReportQuestion;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/ReportQuestion.jsx